import {TimeApiClient} from 'packages/request';

type PushNotificationConfig = {
    VapidPublicKey: string;
}

export async function getPushConfig() {
    return (await TimeApiClient.get<PushNotificationConfig>('/api/v4/config/push')).data;
}

export async function updatePWASession(subscription: PushSubscription) {
    return (await TimeApiClient.put('/api/v4/users/sessions/pwa', subscription.toJSON())).data;
}
